import { render, staticRenderFns } from "./TabPrices.vue?vue&type=template&id=55f2b5c4&scoped=true&"
import script from "./TabPrices.vue?vue&type=script&lang=js&"
export * from "./TabPrices.vue?vue&type=script&lang=js&"
import style0 from "./TabPrices.vue?vue&type=style&index=0&id=55f2b5c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f2b5c4",
  null
  
)

export default component.exports